import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/_components/dialog";
import { ExtendedSupplementDataDto } from "../types/supplementDataTypes";
import { Edit2Icon } from "lucide-react";
import CreateSupplementDataForm from "../forms/CreateSupplementDataForm";
import { Button } from "@/components/_components/button";
import { useState } from "react";

interface CreateSupplementDataDialogProps {
  supplementData?: ExtendedSupplementDataDto;
  type?: string;
}

const CreateSupplementDataDialog = ({
  supplementData,
  type,
}: CreateSupplementDataDialogProps) => {
  const [open, setOpen] = useState(false);
  const isEditMode = Boolean(supplementData);
  const dialogButtonLabel = isEditMode ? (
    <Edit2Icon />
  ) : (
    "Add " + (type ? type : "Master Data")
  );

  const getDialogTitle = () => {
    if (isEditMode) {
      return `Edit ${supplementData?.type || 'Master Data'}`;
    }
    return `Add ${type || 'Master Data'}`;
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          size={isEditMode ? "icon" : "default"}
          variant={isEditMode ? "outline" : "default"}
        >
          {dialogButtonLabel}
        </Button>
      </DialogTrigger>
      <DialogContent 
        aria-describedby={undefined}
        className="sm:max-w-[600px] max-h-[90vh] overflow-y-auto"
      >
        <DialogHeader className="pb-4 border-b border-border/50">
          <DialogTitle className="text-xl font-bold text-foreground">
            {getDialogTitle()}
          </DialogTitle>
        </DialogHeader>
        <div className="pt-4">
          <CreateSupplementDataForm 
            type={type} 
            supplementData={supplementData} 
            onClose={handleClose}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CreateSupplementDataDialog;